import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import generateColors from "shared/utils/generateColors";

// Register necessary components from Chart.js
ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

function getRandomIntegers(min: number, max: number, count: number) {
  const randomIntegers = [];

  for (let i = 0; i < count; i++) {
    // Generate a random integer between min and max (inclusive)
    const randomInteger = Math.floor(Math.random() * (max - min + 1)) + min;
    randomIntegers.push(randomInteger);
  }

  return randomIntegers;
}

const BarChartWithRoundedBars = ({ items }: any) => {
  let datasets: any = [];
  let labels = ["Jan", "Feb", "Mar", "Apr", "May"];
  let distinctColors = generateColors(items.length);
  for (let i = 0; i < items.length; i++) {
    let obj = {
      label: items[i],
      data: getRandomIntegers(30, 100, labels.length),
      backgroundColor: distinctColors[i],
      borderRadius: 100, // Rounded corners
      barPercentage: 1.0, // No spacing between bars
      // categoryPercentage: 1.0, // No spacing for categories
    };
    datasets.push(obj);
  }

  const data = {
    labels, // Labels for the x-axis (months)
    datasets,
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

  return (
    <div style={{ minHeight: "400px", width: "100%" }}>
      {/* @ts-ignore */}
      <Bar data={data} options={options} />
    </div>
  );
};

export default BarChartWithRoundedBars;
